export { default as Profile } from './profile/profile';


// WEBPACK FOOTER //
// ./src/bundles/profile/components/index.ts